import BaseCellRenderer, { IBaseCellRendererParams } from "./BaseCellRenderer";

export default function IntegerCellRenderer(props: IBaseCellRendererParams<number>) {
    const int = props.valueFormatted != null ? (props.valueFormatted === "" ? null : Number.parseInt(props.valueFormatted)) : props.value;

    return (
        <BaseCellRenderer {...props}>
            {int != null && <>{Math.round(int)}</>}
        </BaseCellRenderer>
    );
}